var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"page-wrap FinanceDetail-page"},[_c('List',{ref:"list",attrs:{"refresh":false,"label":_vm.label,"apiName":"petSettlementDetail","options":_vm.options,"noPage":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }